"use strict";

var _regeneratorRuntime = require("/opt/build/repo/app/node_modules/@babel/runtime/regenerator/index.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnalytics = exports.getCookie = void 0;

var axios_1 = __importDefault(require("axios"));

var package_json_1 = __importDefault(require("../../package.json"));

var hooks_1 = require("../hooks");

var utility_1 = require("../utility");

function getCookie(name) {
  var _a, _b;

  try {
    if (typeof window === "undefined") {
      return "";
    }

    var cookie = "; ".concat(document.cookie).split("; ".concat(name, "="));

    if (cookie.length === 2) {
      return (_b = (_a = cookie.pop()) === null || _a === void 0 ? void 0 : _a.split(";").shift()) !== null && _b !== void 0 ? _b : "";
    }
  } catch (error) {
    console.error(error);
  }

  return "";
}

exports.getCookie = getCookie;

var useAnalytics = function useAnalytics() {
  var _ref = (0, hooks_1.useReactifySearchContext)(),
      options = _ref.options;

  var track = function track(event) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var events;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (options.shopifyPermanentDomain) {
                _context.next = 3;
                break;
              }

              console.warn(new Error('Unable to send tracking event, missing value for "shopifyPermanentDomain".'));
              return _context.abrupt("return");

            case 3:
              utility_1.debug.log("useAnalytics", "track", event);
              events = getTrackEvents(event);
              return _context.abrupt("return", axios_1.default.post("https://analytics.usereactify.com/record/", {
                events: events
              }, {
                headers: {
                  "x-reactify-shop": options.shopifyPermanentDomain,
                  "x-reactify-mode": options.mode,
                  "x-reactify-client-id": options.clientId,
                  "x-reactify-client-version": package_json_1.default.version,
                  "x-reactify-ga": getCookie("_rs_ga")
                }
              }));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };

  return {
    track: track
  };
};

exports.useAnalytics = useAnalytics;

function getTrackEvents(event) {
  var eventName = event.eventName;
  var events = [];

  switch (eventName) {
    case "search":
      events = [{
        eventName: eventName,
        payload: Object.assign(Object.assign({}, event.payload), {
          searchTerm: event.payload.searchTerm.trim()
        })
      }];
      break;

    case "zeroResults":
      events = [{
        eventName: eventName,
        payload: Object.assign(Object.assign({}, event.payload), {
          searchTerm: event.payload.searchTerm.trim()
        })
      }];
      break;

    case "viewProduct":
      events = [{
        eventName: eventName,
        payload: event.payload
      }];
      break;

    case "clickProduct":
      events = [{
        eventName: eventName,
        payload: event.payload
      }];
      break;

    case "viewPromotion":
      events = [{
        eventName: eventName,
        payload: event.payload
      }];
      break;

    case "clickPromotion":
      events = [{
        eventName: eventName,
        payload: event.payload
      }];
      break;

    case "paginationChange":
      events = [{
        eventName: eventName,
        payload: event.payload
      }];
      break;

    case "sortChange":
      events = [{
        eventName: eventName,
        payload: event.payload
      }];
      break;

    case "filterChange":
      events = [{
        eventName: eventName,
        payload: event.payload
      }];
      break;
  }

  return events;
}